// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"d970553c","205":"a0121800","227":"ea5cdafd","232":"41a6db35","237":"848916f5","284":"8b6982a6","357":"a80aaf25","498":"9a04fced","501":"01237c13","526":"3b0ad1ac","692":"5df1dcf4","787":"7da95b79","872":"bb0ac4f4"}[chunkId] + ".chunk.js";
};